import * as React from 'react'
import Container from '@/components/Container'
import SingleAccordion from '@/components/Blocks/Modules/Accordion/SingleAccordion'

import { motion } from 'framer-motion'
import { fadeIn } from '@/lib/utils/framer-motion-config'

import {
    StandardPageQuery_entry_page_page_Entry_modules_modules_accordion_BlockType,
    StandardPageQuery_entry_page_page_Entry_modules_modules_accordion_BlockType_children_modules_accordionItem_BlockType,
} from '@/gql/types/StandardPageQuery'
import { SiteWideQuery_globalSet } from '@/gql/types/SiteWideQuery'

import GetThemeColourByDefault from '@/lib/utils/get-theme-colour-by-default'

type AccordionType = {
    data: StandardPageQuery_entry_page_page_Entry_modules_modules_accordion_BlockType
    siteWide: SiteWideQuery_globalSet
}

const Accordion: React.FunctionComponent<AccordionType> = ({ data, siteWide }) => {
    // This approach is if you only want max one section open at a time. If you want multiple
    // sections to potentially be open simultaneously, they can all be given their own `useState`.
    const [expanded, setExpanded] = React.useState<false | number>(
        data.defaultOpen && data.defaultOpen.length && data.defaultOpen[0] === 'open' ? 0 : false
    )
    data.theme = GetThemeColourByDefault(data.theme!)

    return (
        <Container
            maxWidth="md"
            paddingYPreset="md"
            curved={data.theme === 'black' ?? true}
            theme={data.theme}
        >
            <motion.h2
                className="mb-4 text-4xl font-black sm:text-5xl"
                {...fadeIn}
            >
                {data?.heading!}
            </motion.h2>
            {data.children &&
                data.children.map(
                    (item, index) =>
                        item !== null && (
                            <SingleAccordion
                                key={index}
                                index={index}
                                expanded={expanded}
                                setExpanded={setExpanded}
                                data={
                                    item as StandardPageQuery_entry_page_page_Entry_modules_modules_accordion_BlockType_children_modules_accordionItem_BlockType
                                }
                            />
                        )
                )}
        </Container>
    )
}

export default Accordion
